// Texty ovladače našeptávače (searchWhisperer.js) — přídavky nativního panelu.
export default {
  suggests: 'Našeptané dotazy',
  hint: '↑ ↓ pohyb · Enter otevře',
  // rotující placeholder pole hledání: prefix + populární dotaz + suffix
  placeholderPrefix: 'Hledat „',
  placeholderSuffix: '“',
};
